import { render } from "./SoftwareUpdate.vue?vue&type=template&id=1be063ee"
import script from "./SoftwareUpdate.vue?vue&type=script&lang=ts"
export * from "./SoftwareUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script